import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { trim } from 'lodash';
import { environment } from '../../../environments/environment';

@Injectable()
export class CookieService {
  private _expireDays = 30; // same as refresh token on OAuth

  constructor(@Inject(DOCUMENT) private _document: Document) {}

  getCookie(key: string) {
    const cookies: string[] = this._document.cookie.split(';');
    const cookieName = key + '=';

    for (let i = 0; i < cookies.length; i++) {
      const cookie = trim(cookies[i]);

      if (cookie.indexOf(cookieName) === 0) {
        return cookie.substring(cookieName.length, cookie.length);
      }
    }
    return '';
  }

  getAllCookies(): string {
    return this._document.cookie;
  }

  setCookie(
    key: string,
    value: string | number | boolean,
    expireDays: number = this._expireDays,
    path: string = '/',
    domain: string = environment.domain
  ) {
    const d: Date = new Date();

    d.setTime(d.getTime() + expireDays * 24 * 60 * 60 * 1000);

    let cookie = `${key}=${value};expires=${d.toUTCString()};path=${path}`;

    if (domain) {
      cookie += `;domain=${domain}`;
    }

    this._document.cookie = cookie;
  }

  removeCookie(
    key: string,
    path: string = '/',
    domain: string = environment.domain
  ) {
    this.setCookie(key, '', -1, path, domain);
  }
}
